import { Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ThemeProvider } from "styled-components";

import theme from "../../theme";

import "./module.scss";
import {
  AdminContainer,
  HeaderContainer,
  NavigatorContainer,
  LayoutContainer,
  FooterContainer
} from "./style";

import AdminHeader from "../Header";
import AdminNavigator from '../Navigator';
// import Footer from "../../../../ui/Footer";

const AdminLayout = () => {
  console.log('AdminLayout', useSelector(store => store));

  return (
    <ThemeProvider theme={theme}>
      <AdminContainer id="mspbackend">
        <HeaderContainer>
          <AdminHeader />
        </HeaderContainer>
        <NavigatorContainer>
          <AdminNavigator />
        </NavigatorContainer>
        <LayoutContainer>
          <Outlet />
        </LayoutContainer>
        <FooterContainer>
          {/* <Footer /> */}
        </FooterContainer>
      </AdminContainer>
    </ThemeProvider>
  )
}

export default AdminLayout